
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2R6UY = parcelRequire("2R6UY");
"use strict";
// Default values
let $e3902a0925380229$var$config = {
    relay: "polkadot",
    y: "normal",
    title2: "(Average)",
    metric: "avg",
    currentTheme: localStorage.getItem("theme") || "light"
};
document.addEventListener("DOMContentLoaded", ()=>{
    $e3902a0925380229$var$initializeConfig($e3902a0925380229$var$config);
    $e3902a0925380229$var$initializeListeners($e3902a0925380229$var$config);
    $e3902a0925380229$var$initializeCharts($e3902a0925380229$var$config);
});
function $e3902a0925380229$var$initializeConfig(config) {
    config.chartsConfig = $e3902a0925380229$var$updateChartsConfig(config);
}
function $e3902a0925380229$var$initializeListeners(config) {
    const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
    toggleSwitch.addEventListener("change", (e)=>{
        config.currentTheme = e.target.checked ? "dark" : "light";
        localStorage.setItem("theme", config.currentTheme);
        document.body.classList.toggle("dark-mode", config.currentTheme === "dark");
        $e3902a0925380229$var$updateChartsConfig(config);
    });
    [
        "ySelection",
        "relaySelection",
        "metricSelection"
    ].forEach((selection)=>{
        document.querySelectorAll(`input[name="${selection}"]`).forEach((radio)=>{
            radio.onchange = function() {
                config[selection.split("Selection")[0]] = this.value;
                $e3902a0925380229$var$updateChartsConfig(config);
            };
        });
    });
    if (localStorage.getItem("theme") === "dark") {
        toggleSwitch.checked = true;
        document.body.classList.add("dark-mode");
    }
}
function $e3902a0925380229$var$initializeCharts(config) {
    $e3902a0925380229$var$updateChartsConfig(config);
}
function $e3902a0925380229$var$updateChartsConfig(config) {
    if (config.y === "average") config.title2 = "(Average)";
    else config.title2 = "(Max)";
    config.chartsConfig = [
        $e3902a0925380229$var$createChartConfig("general_avg_weights", config, config.y.concat("_avg")),
        $e3902a0925380229$var$createChartConfig("general_max_weights", config, config.y.concat("_max"))
    ];
    config.chartsConfig.forEach((cfg)=>{
        const chart = $2R6UY.createEchartElement(cfg.elementId, config.currentTheme);
        if (chart) $2R6UY.loadJSONData(cfg.jsonPath, cfg.relay, (data)=>{
            cfg.build(cfg, data, chart); // Pass chart instance to build function
        }, chart);
        else console.error(`Failed to create chart for element ${cfg.elementId}`);
    });
}
function $e3902a0925380229$var$createChartConfig(elementId, config, yName) {
    return {
        elementId: elementId,
        jsonPath: `data/block_weights000000000000.jsonl`,
        freq: "daily",
        relay: config.relay,
        yName: yName,
        build: $2R6UY.barchart
    };
}


//# sourceMappingURL=block_weights.2753efea.js.map
